import { render, staticRenderFns } from "./LanguageToggle.vue?vue&type=template&id=699defb0"
import script from "./LanguageToggle.vue?vue&type=script&lang=js"
export * from "./LanguageToggle.vue?vue&type=script&lang=js"
import style0 from "./LanguageToggle.vue?vue&type=style&index=0&id=699defb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports